import { useState, useEffect, useRef } from "react";
import "./ActionPanel.css";
import { Form, InputGroup, Button } from "react-bootstrap";
import HistorySection from "../../../operations/components/WorkScreen/HistorySection";
import Select from "react-select";
import { createFilter } from "react-select";
import { toast } from "react-toastify";

import { useDispatch, useSelector } from "react-redux";
import {
  fetchWorkScreenData,
  postWorkScreenData,
} from "../../../redux/slices/operationHomeSlice";
import { useNavigate } from "react-router-dom";
import { FiChevronDown } from "react-icons/fi";

const ActionPanel = ({ memberId, callId, show, setShow }) => {
  const panelRef = useRef(null);

  memberId = memberId.replace(
    /([a-zA-Z]{2})(\d+)/,
    (match, letters, numbers) => `${letters.toUpperCase()} ${numbers}`,
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [assignee, setAssignee] = useState(null);
  const data = useSelector((state) => state.operationHome.workScreenData);
  const isWorkScreenLoading = useSelector(
    (state) => state.operationHome.isWorkScreenLoading,
  );
  const requestProcessed = useSelector(
    (state) => state.operationHome.requestProcessed,
  );
  const requestError = useSelector((state) => state.operationHome.requestError);

  const [isUpdated, setIsUpdated] = useState(false);
  const [newMessage, setNewMessage] = useState("");
  const [chats, setChats] = useState([]);
  const [statusColour, setStatusColour] = useState("#FEDAD9");
  const [hasChanges, setHasChanges] = useState(false);
  const [initialState, setInitialState] = useState({
    status: "",
    assigneeId: "",
    notes: "",
  });

  const [payloadData, setPayloadData] = useState({
    status: "",
    assigneeId: "",
    assigneeName: "",
  });

  const [workScreenData, setWorkScreenData] = useState({
    issueId: "",
    callId: "",
    callCategory: "",
    customerName: " ",
    agentName: " ",
    status: "",
    assigneeName: "",
    assigneeId: "",
    notes: [],
    history: [],
    changeSubscription: "",
    assignee: [],
  });

  const [status, setStatus] = useState([
    { text: "Open", value: "Yes" },
    { text: "In-Progress", value: "In-Progress" },
    { text: "Closed", value: "Closed" },
  ]);

  useEffect(() => {
    dispatch(fetchWorkScreenData({ memberId, callId }));
  }, [callId]);

  useEffect(() => {
    // only update when we have a valid record. guard against
    // the case where saga refetches with callId=null and returns
    // an empty response that would otherwise wipe out our fields.
    if (data && data.issueId) {
      const merged = [...(data.notes || []), ...(data.history || [])].sort(
        (a, b) => new Date(a.createdOn) - new Date(b.createdOn),
      );
      setChats(merged);
      setWorkScreenData({
        issueId: data.issueId,
        callId: callId,
        callCategory: data.callCategory,
        customerName: data.customerName,
        agentName: data.agentName,
        status: data.status,
        assigneeName: data.assigneeName,
        assigneeId: data.assigneeId,
        notes: data.notes || [],
        history: data.history || [],
        changeSubscription: data.changeSubscription,
        assignee: data.assignee || [],
      });

      if (data.status === "Open") setStatusColour("#FEDAD9");
      else if (data.status === "In-Progress") setStatusColour("#E8F0FB");
      else if (data.status === "Closed") setStatusColour("#FDEBF9");

      setPayloadData({
        status: data.status,
        assigneeId: data.assigneeId,
        assigneeName: data.assigneeName,
      });

      // Set initial state for change detection
      setInitialState({
        status: data.status,
        assigneeId: data.assigneeId,
        notes: "",
      });
    }
  }, [data]);

  // Detect changes in form fields
  useEffect(() => {
    const statusChanged = payloadData.status !== initialState.status;
    const assigneeChanged = payloadData.assigneeId !== initialState.assigneeId;
    const notesChanged = newMessage.trim() !== "";

    setHasChanges(statusChanged || assigneeChanged || notesChanged);
  }, [payloadData, newMessage, initialState]);

  useEffect(() => {
    if (!show) return undefined;

    const handlePointerDownOutside = (event) => {
      const clickTarget = event.target;

      if (!(clickTarget instanceof Node)) return;
      // If click is inside panel, keep it open
      if (panelRef.current?.contains(clickTarget)) return;
      // Ignore clicks inside any react-select control or menu (classNamePrefix = action-panel-select)
      if (clickTarget.closest('[class*="action-panel-select"]')) return;
      // legacy check for portal class
      if (clickTarget.closest(".action-panel-select__menu-portal")) return;

      setShow(false);
    };

    document.addEventListener("mousedown", handlePointerDownOutside);

    return () => {
      document.removeEventListener("mousedown", handlePointerDownOutside);
    };
  }, [show, setShow]);

  const LoginUserData = useSelector((state) => state.login);

  const handleSendMessage = () => {
    const payload = {
      customerId: memberId,
      issueId: data.issueId,
      notes: newMessage,
      noteAddedBy: `${LoginUserData.login.data.data[0].FirstName} ${LoginUserData.login.data.data[0].LastName}`,
      noteAddedUserId: LoginUserData.login.data.data[0].AdminID,
      callId: callId,
      assigneeId: payloadData.assigneeId,
      senderName: `${LoginUserData.login.data.data[0].FirstName} ${LoginUserData.login.data.data[0].LastName}`,
    };
    dispatch(postWorkScreenData(payload, "callId"));
    setNewMessage("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault(); // block enter
    }
  };

  const postData = async () => {
    const selectedAssignee = data.assignee.find(
      (obj) => String(obj.assigneeId) === String(payloadData.assigneeId),
    );

    const payload = {
      customerId: memberId,
      issueId: data.issueId,
      status: payloadData.status,
      callId: callId,
      assigneeName: selectedAssignee ? selectedAssignee.assigneeName : (payloadData.assigneeName || ""),
      assigneeId: selectedAssignee ? selectedAssignee.assigneeId : (payloadData.assigneeId || null),
    };

    try {
      if (newMessage.trim()) {
        handleSendMessage();
      }
      dispatch(postWorkScreenData(payload));

      console.log(payload, "Rohit action");

      // Show success toast with details
      const changes = [];
      if (payloadData.status !== initialState.status) {
        changes.push(`Status changed to ${payloadData.status}`);
      }
      if (payloadData.assigneeId !== initialState.assigneeId) {
        changes.push(
          `Assigned to ${payload.assigneeName || "Unassigned"}`,
        );
      }
      if (newMessage.trim()) {
        changes.push("Note added");
      }

      const toastMessage =
        changes.length > 0
          ? `Saved!\n${changes.join("\n")}`
          : "Changes saved successfully";

      toast.success(toastMessage, {
        icon: false,
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      // Reset changes
      setHasChanges(false);
      setNewMessage("");
      setInitialState({
        status: payloadData.status,
        assigneeId: payloadData.assigneeId,
        notes: "",
      });
      setWorkScreenData((prev) => ({
        ...prev,
        status: payload.status,
        assigneeId: payload.assigneeId,
        assigneeName: payload.assigneeName,
      }));
      setPayloadData((prev) => ({
        ...prev,
        status: payload.status,
        assigneeId: payload.assigneeId,
        assigneeName: payload.assigneeName,
      }));
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("✗ Failed to save changes. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setPayloadData({ ...payloadData, [name]: value });

    if (value === "Open") setStatusColour("#FEDAD9");
    else if (value === "In-Progress") setStatusColour("#E8F0FB");
    else if (value === "Closed") setStatusColour("#FDEBF9");
  };

  // map assignees to options and keep assigneeName for easy lookup
  const options = workScreenData?.assignee?.map((obj) => ({
    value: obj.assigneeId,
    label: `${String(obj.assigneeId).includes("A") ? "⚫" : "🔵"} ${obj?.assigneeName} (${obj?.assigneeId})`,
    assigneeName: obj.assigneeName,
  }));

  // handler for assignee select so clearing and selection are explicit
  const handleAssigneeChange = (selected) => {
    if (selected) {
      // selected may include assigneeName property
      const assigneeName = selected.assigneeName
        ||
        // fallback: try to find in workScreenData
        (workScreenData?.assignee?.find((a) => String(a.assigneeId) === String(selected.value)) || {}).assigneeName
        || "";

      setPayloadData((prev) => ({
        ...prev,
        assigneeId: selected.value,
        assigneeName,
      }));
    } else {
      // cleared via the 'x' button: set to null/empty explicitly
      setPayloadData((prev) => ({ ...prev, assigneeId: null, assigneeName: "" }));
    }
  };

  const statusOptions = status.map((obj) => ({
    value: obj.value,
    label: obj.text,
  }));

  const getStatusColor = (status) => {
    switch (status) {
      case "Open":
        return { bg: "#FDECEA", text: "#8E1F0B" };
      case "In-Progress":
        return { bg: "#E7F1FF", text: "#3786F1" };
      case "Closed":
        return { bg: "#FCE4F6", text: "#EE61CF" };
      default:
        return { bg: "#EEE", text: "#000" };
    }
  };

  const selectedOption =
    statusOptions.find((o) => o.value === payloadData.status) || null;

  const currentColors = getStatusColor(payloadData.status);
  const toggleLabel = show ? "Collapse" : "Expand";

  return (
    <div
      ref={panelRef}
      className={`action-panel ${show ? "expanded" : "collapsed"}`}
    >
      <header onClick={() => !show && setShow(true)}>
        <h2>Action Panel</h2>
        <div
          className="status-assignee"
          onClick={(e) => e.stopPropagation()}
        style={{ display: "flex", gap: "20px", alignItems: "center" }}
        >
          {/* Assignee Dropdown */}
          <div className="WS-select-field1">
            <label className="WS-select-label">Assignee:</label>
            <div className="custom-select">
<Select
  classNamePrefix="action-panel-select"
  options={options}
  value={
    (options &&
      options.find(
        (o) => String(o.value) === String(payloadData.assigneeId),
      )) ||
    null
  }
  onChange={(selected) => handleAssigneeChange(selected)}
  isSearchable={true}
  isClearable={true}
  filterOption={createFilter({ ignoreAccents: false })}
  noOptionsMessage={() => "No assignees found"}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  styles={{
    menuPortal: (base) => ({
      ...base,
      zIndex: 99999,
    }),

    control: (base) => ({
      ...base,
      minWidth: 220,
      fontSize: 12,
    }),

    menu: (base) => ({
      ...base,
      width: "100%",
      minWidth: "260px",
      borderRadius: "8px",
      overflow: "hidden",
      zIndex: 99999,
    }),

    menuList: (base) => ({
      ...base,
      maxHeight: 240,
      fontSize: 12,
      overflowY: "auto",
      paddingTop: 0,
      paddingBottom: 0,
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#f3f4f6" : "#fff",
      color: "#222",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }),

    singleValue: (base) => ({
      ...base,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }),
  }}
/>
              {/* <select
                className="select-value"
                value={payloadData.assigneeId}
                onChange={handleChange}
                name="assigneeId"
                style={{
                  border: "2px solid #EBEBEB",
                  width: "136px",
                  height: "38px",
                  borderRadius: "5px",
                  fontSize: "11px",
                }}
              >
                {workScreenData?.assignee?.map((obj, index) => (     
                  <option key={index} value={obj.assigneeId}>
                    ⚫ {obj.assigneeName} 
                  </option>
                ))}
              </select> */}
            </div>
          </div>

          {/* Status Dropdown */}
          <div className="WS-select-field1">
            <label className="WS-select-label">Status:</label>
            <div
              className="custom-select"
              style={{
                // border: "2px solid #EBEBEB",
                width: "115px",
                height: "38px",
                // padding: "4px",
                // borderRadius: "5px",
              }}
            >
              <Select
                classNamePrefix="action-panel-select"
                options={statusOptions}
                value={selectedOption}
                onChange={(selected) =>
                  handleChange({
                    target: { name: "status", value: selected?.value },
                  })
                }
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: currentColors.bg,
                    // borderRadius: "10px",
                    // width: "90px",
                    // height: "28px",
                    // minHeight: "28px",
                    fontSize: "12px",
                    fontWeight: "550",
                    border: "none",
                    boxShadow: "none",
                    cursor: "pointer",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: currentColors.text,
                  }),
                  indicatorSeparator: () => ({
                    display: "none",
                  }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    padding: "2px",
                  }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menuList: (base) => ({
                    ...base,
                    maxHeight: 150,
                    overflowY: "auto",
                  }),
                }}
              />
              {/* <select
                className="select-value"
                value={payloadData.status}
                onChange={handleChange}
                name="status"
                style={{
                  backgroundColor: statusColour,
                  borderRadius: "10px",
                  width: "90px",
                  height: "28px",
                  fontSize: "11px",
                  fontWeight: "550",
                  border: "none",
                  outline: "none",
                  color:
                    payloadData.status === "Open"
                      ? "#8E1F0B"
                      : payloadData.status === "In-Progress"
                        ? "#3786F1"
                        : payloadData.status === "Closed"
                          ? "#EE61CF"
                          : "#000",
                }}
              >
                {status.map((obj) => (
                  <option
                    key={obj.value}
                    value={obj.value}
                    style={{ backgroundColor: "white", color: "black" }}
                  >
                    {obj.text}
                  </option>
                ))}
              </select> */}
            </div>

            {/* Toggle button OUTSIDE dropdown */}
            <button
              className="action-panel-toggle"
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setShow((prev) => !prev);
              }}
              style={{
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontSize: "14px",
                marginLeft: "6px",
                padding: 0,
              }}
              aria-label={`${toggleLabel} action panel`}
              title={toggleLabel}
            >
              <span className="action-panel-toggle-text">{toggleLabel}</span>
              <FiChevronDown
                aria-hidden="true"
                style={{
                  transition: "transform 0.2s ease",
                  transform: show ? "rotate(180deg)" : "rotate(0deg)",
                }}
              />
              {/* {show ? "▲" : "▼"} */}
            </button>
          </div>
        </div>
      </header>

      {/* Expandable Content */}
      {show && (
        <div className="action-content">
          <div className="action-notes">
            <div className="chat-section-header">Chat</div>

            <HistorySection chats={chats} />

            <InputGroup className="mt-3">
              <Form.Control
                type="text"
                placeholder="Reply or post an Update"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onKeyDown={handleKeyDown}
                className="custom-placeholder"
              />
            </InputGroup>
          </div>

          <Button
            className="WS-save-btn-actionPanel"
            type="button"
            onClick={postData}
            disabled={!hasChanges}
            style={{
              opacity: hasChanges ? 1 : 0.5,
              cursor: hasChanges ? "pointer" : "not-allowed",
            }}
          >
            Save
          </Button>
        </div>
      )}
    </div>
  );
};

export default ActionPanel;
